export const COMPONENTS = {
  MODAL_LOGIN_SIGNUP: 'ae-login-signup-modal',
  MODAL_SIGNUP: 'ae-signup-modal',
  MODAL_CHECKOUT: 'ae-checkout-modal',
  MODAL_LOGIN: 'ae-login-modal',
  MODAL_FORGOT_PASSWORD: 'ae-forgot-password-modal',
  SCRIPT_ANGULARE: 'script-angulare',
}
